export class PrestadorModeloConsulta{
    constructor(){}

    Nombre = ""
    IdTipo = ""
    IdProvincia = ""
}